module.exports = "img{\r\n\tmargin: 10px auto;display: block;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/nadhmi/nadhmi.component.css
// module id = ./src/app/nadhmi/nadhmi.component.css
// module chunks = main